<template>
    <div class="table-container">
        <!-- 固定顶部区域 -->
        <div class="fixed-header">
            <el-button type="primary" :disabled="loading" @click="openDialog">新建</el-button>
        </div>
        
        <!-- 表格区域 -->
        <div class="table-wrapper">
            <el-table v-loading="loading" :data="data" scroll-x="1600px" fit>
                <el-table-column label="ID" width="150" prop="id"></el-table-column>
                <el-table-column label="图片" width="300px" prop="cover">
                    <template #default="scope">
                        <el-image lazy :src="`${$CDN_URL}/${scope.row.cover}`"
                                  style="width: 250px"></el-image>
                    </template>
                </el-table-column>
                <el-table-column label="类型" width="150">
                  <template #default="scope">
                    {{type_map[scope.row.type]}}
                  </template>
                </el-table-column>
                <el-table-column label="目标" width="150" prop="target"></el-table-column>
                <el-table-column label="时间" width="150"></el-table-column>
                <el-table-column label="上线" width="100px" prop="active">
                    <template #default="scope">
                        <el-switch v-model="scope.row.active" :inactive-value="false" :active-value="true"
                                   @change="update(scope.row)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="250">
                    <template #default="scope">
                        <el-button type="success" circle icon="Top" :loading="loading"
                                   :disabled="scope.$index===0" @click="moveUp(scope.$index)"></el-button>
                        <el-button type="success" circle icon="Bottom" :loading="loading"
                                   :disabled="scope.$index===data.length - 1" @click="moveDown(scope.$index)"></el-button>
                        <el-button size="small" :disabled="loading" @click="openDialog(scope.row)">编辑</el-button>
                        <el-button size="small" type="danger" :disabled="loading" @click="remove(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        
        <!-- 固定分页区域 -->
        <div class="fixed-pagination">
            <div style="display: flex; justify-content: space-between">
              <el-pagination layout="prev, pager, next" :total="total" :page-size="this.query.limit"
                             @current-change="pageChange" :disabled="loading"></el-pagination>
              <el-select v-model="query.limit" style="width: 100px" @change="reload" :disabled="loading">
                <el-option :value="20"></el-option>
                <el-option :value="50"></el-option>
                <el-option :value="100"></el-option>
              </el-select>
            </div>
        </div>
    </div>
    <el-dialog v-model="dialog_opened" :before-close="reset" width="800px" max-height="80vh" append-to-body>
        <div class="dialog-content" style="max-height: calc(80vh - 100px); overflow-y: auto;">
            <el-form :model="form" ref="form" label-width="100px">
                <el-form-item label="游戏" prop="game_id" :rules="[{required: true, message: '请选择游戏'}]">
                  <el-select v-model="form.game_id" :disabled="loading" filterable>
                    <el-option v-for="c in game_list" :label="c.name" :value="c.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="活动类型" prop="type" :rules="[{required: true, message: '请选择类型'}]">
                  <el-select v-model="form.type" :disabled="loading" filterable>
                    <el-option v-for="c in [0]" :label="type_map[c]" :value="c"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="活动目标" prop="target" :rules="[{required: true, message: '请选择类型'}]">
                  <el-input v-model="form.target" :disabled="loading" type="number" style="width: 200px;"></el-input>
                </el-form-item>

                <el-form-item label="开始时间" prop="start" :rules="[{required: true, message: '请选择类型'}]">
                  <el-date-picker value-format="YYYY-MM-DD" :disabled="loading" v-model="form.start" style="width: 200px"></el-date-picker>
                </el-form-item>

                <el-form-item label="结束时间" prop="end" :rules="[{required: true, message: '请选择类型'},
                  { validator: (rule, value, callback) => (form.start && value && value <= form.start) ?
                    callback('结束时间必须大于开始时间') : callback() }]">
                  <el-date-picker value-format="YYYY-MM-DD" :disabled="loading" v-model="form.end" style="width: 200px"></el-date-picker>
                </el-form-item>

                <el-form-item label="活动描述" prop="desc" :rules="[{required: false, message: '请输入活动描述'}]">
                  <el-input v-model="form.desc" :disabled="loading"></el-input>
                </el-form-item>

                <el-form-item label="海报" prop="cover" :rules="[{required: true, message: '请上传封面图'}]">
                    <el-upload :http-request="handleUpload" :show-file-list="false"
                               accept="image/*">
                        <img v-if="form.cover" :src="`${$CDN_URL}/${form.cover}`" style="width: 200px">
                        <el-button size="small" v-else :loading="loading">上传</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
        </div>
        <template #footer>
            <el-button type="primary" :loading="loading" @click="reset" text>取消</el-button>
            <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
        </template>
    </el-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {update, deepcopy} from "../../utils/utils";
import {ElMessageBox} from 'element-plus'
import {GameTaskApi, GameTask} from '../../api/gameTaskApi';
import {GameApi, Game} from '../../api/gameApi';

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $CDN_URL: string;
  }
}

export default defineComponent({
    name: "GameTask",
    data() {
        return {
            loading: false,
            data: [] as GameTask[],
            editing: null as GameTask | null,
            dialog_opened: false,
            game_list: [] as Game[],
            type_map: {0: "时长活动"} as Record<number, string>,
            total: 0,
            page: 1,
            query: {
                limit: 20,
                skip: 0
            },
            form: {
                cover: '',
                game_id: "",
                type: 0,
                target: null as number | null,
                start: null as string | null,
                end: null as string | null,
                active: false,
                desc: ""
            } as GameTask,
        }
    },
    methods: {
        init(): void {
            this.loading = true;
            Promise.all([
                GameTaskApi.getGameTasks(this.query),
                GameApi.getGames({ limit: 1000 })
            ])
            .then(([tasksRes, gamesRes]) => {
                this.data = tasksRes;
                this.total = tasksRes.length;
                this.game_list = gamesRes.gameList;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        pageChange(page: number): void {
            this.query.skip = (page - 1) * this.query.limit;
            this.init();
        },
        reload(): void {
            this.query.skip = 0;
            this.page = 1;
            this.init();
        },
        openDialog(item?: GameTask): void {
            this.dialog_opened = true;
            this.$nextTick(() => {
                if (item) {
                    update(this.form, item);
                    this.editing = item;
                }
            })
        },
        reset(): void {
            (this.$refs.form as any).resetFields();
            this.dialog_opened = this.loading = false;
            this.editing = null;
        },
        submit(): void {
            (this.$refs.form as any).validate((valid: boolean) => {
                if (valid) {
                    this.loading = true;
                    if (this.editing) {
                        GameTaskApi.updateGameTask(this.editing.id, this.form)
                            .then(res => {
                                update(this.editing, res);
                                this.reset();
                            })
                            .finally(() => this.loading = false);
                    } else {
                        GameTaskApi.createGameTask(this.form)
                            .then(res => {
                                this.data.push(res);
                                this.reset();
                            })
                            .finally(() => this.loading = false);
                    }
                }
            })
        },
        remove(row: GameTask): void {
            ElMessageBox.confirm('确定要删除该项吗？', '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning',
            }).then(() => {
                this.loading = true;
                GameTaskApi.deleteGameTask(row.id)
                    .then(() => {
                        this.data.splice(this.data.indexOf(row), 1);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }).catch(() => {
            });
        },
        async handleUpload({ file }: { file: File }): Promise<void> {
            this.loading = true;
            try {
                const fileName = await GameApi.uploadResource(file, 'game');
                this.form.cover = fileName;
            } catch (error) {
                (this as any).$message.error('上传失败');
            } finally {
                this.loading = false;
            }
        },
        update(row: GameTask): void {
            this.loading = true;
            GameTaskApi.updateGameTask(row.id, row)
                .then(() => {
                    this.loading = false;
                });
        },
        moveUp(index: number): void {
            const row = this.data.splice(index, 1);
            this.data.splice(index - 1, 0, row[0]);
            this.resort();
        },
        moveDown(index: number): void {
            const row = this.data.splice(index, 1);
            this.data.splice(index + 1, 0, row[0]);
            this.resort();
        },
        resort(): void {
            const sort: string[] = [];
            this.data.forEach(d => {
                sort.push(d.id);
            });
            this.loading = true;
            GameTaskApi.sortGameTasks(sort)
                .then(() => {
                    this.loading = false;
                });
        }
    },
    mounted(): void {
        this.init();
    }
})
</script>

<style scoped>
.table-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 128px); /* 减去header和footer的高度 */
  overflow: hidden;
  background-color: #fff;
}

.fixed-header {
  background-color: #fff;
  padding: 10px 20px;
  border-bottom: 1px solid #ebeef5;
  z-index: 10;
  flex-shrink: 0;
}

.table-wrapper {
  flex: 1;
  overflow: auto;
  margin: 10px 0;
  padding: 0 10px;
  box-sizing: border-box;
}

/* 设置表格高度，使其适应容器 */
.table-wrapper .el-table {
  width: 100%;
  min-width: 1600px;
}

.fixed-pagination {
  background-color: #fff;
  padding: 10px 20px;
  border-top: 1px solid #ebeef5;
  z-index: 10;
  flex-shrink: 0;
}
</style>